export default __webpack_public_path__ + "static/media/lds-logo_sm.35f91967a9a2fd1c.svg";